const languageModule = {
    namespaced: true,
    state: {
        currentLanguage: localStorage.getItem('app-language') || 'fr',
        availableLanguages: [
            { code: 'fr', name: 'Français', flag: '🇫🇷' },
            { code: 'en', name: 'English', flag: '🇬🇧' },
            { code: 'it', name: 'Italiano', flag: '🇮🇹' },
            { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
        ],
    },
    mutations: {
        SET_LANGUAGE(state, language) {
            state.currentLanguage = language;
            localStorage.setItem('app-language', language);
            if (typeof document !== 'undefined') {
                document.documentElement.lang = language;
            }
        },
    },
    actions: {
        setLanguage({ commit, rootState }, language) {
            commit('SET_LANGUAGE', language);
        },
    },
    getters: {
        currentLanguage: (state) => state.currentLanguage,
        availableLanguages: (state) => state.availableLanguages,
        currentLanguageName: (state) => {
            const lang = state.availableLanguages.find(l => l.code === state.currentLanguage);
            return lang ? lang.name : 'Français';
        },
    },
};
export default languageModule;
